import './styles.css'

import { useEffect, useMemo, useState } from 'react'

import { Flex, Spacer, Tabs, VStack } from '@chakra-ui/react'
import { PanelType } from '@editor/config/constants'
import { INFO_PANEL_PADDING } from '@editor/config/styles'
import { Mode } from '@editor/pages/projects/blueprint-editor/definitions'
import { toggleCollapsedPanel } from '@editor/pages/projects/blueprint-editor/store/blueprintEditor'
import { Tools } from '@editor/pages/projects/blueprint-editor/tools/setup'
import CollapsePanel from '@editor/pages/projects/editor/infoPanels/components/CollapsePanel'
import { RootState, useAppDispatch } from '@editor/store/app'
import { useSelector } from 'react-redux'

import BlueprintDrawings from './components/BlueprintDrawings'
import EditorElements from './components/EditorElements'

const ElementsPanel = () => {
  // Store
  const dispatch = useAppDispatch()
  const collapsedPanel = useSelector((state: RootState) => state.blueprint.editor.collapsedPanel)
  const selectedTool = useSelector((state: RootState) => state.blueprint.editor.selectedTool)
  const mode = useSelector((state: RootState) => state.blueprint.editor.mode)

  // State
  const [tabValue, setTabValue] = useState('damage')

  // Derived state
  const currentEditorTool = Tools.find((tool) => tool.key === selectedTool)
  const isCollapsed = useMemo(() => collapsedPanel.includes(PanelType.Elements), [collapsedPanel])
  const canDraw = useMemo(() => mode !== Mode.Editor3D, [mode])

  /**
   * If a tool is configured to switch to the drawing panel when active,
   * switch to the Drawings tab.
   */
  useEffect(() => {
    if (currentEditorTool?.config?.switchToDrawingPanelOnActive) {
      setTabValue('boundary')
    }
  }, [selectedTool, currentEditorTool])
  useEffect(() => {
    if (canDraw) {
      setTabValue('boundary')
    } else {
      setTabValue('damage')
    }
  }, [canDraw])

  return (
    <VStack flex={1} w="100%" gap={0} minH={0}>
      <Flex
        id="elements-panel"
        data-testid="elements-panel"
        className="panel"
        flex={isCollapsed ? 'unset' : 1}
        minH={0}
      >
        <CollapsePanel
          title="要素一覧"
          onChange={() => dispatch(toggleCollapsedPanel(PanelType.Elements))}
          isCollapsed={isCollapsed}
        >
          <Tabs.Root
            value={tabValue}
            onValueChange={(e) => setTabValue(e.value)}
            w="100%"
            pb={INFO_PANEL_PADDING - 1}
            size="sm"
            variant="panel"
          >
            <Tabs.List>
              <Tabs.Trigger value="damage">損傷</Tabs.Trigger>
              <Tabs.Trigger value="boundary">境界</Tabs.Trigger>
            </Tabs.List>
            <Tabs.Content value="damage" p={0}>
              <EditorElements />
            </Tabs.Content>
            <Tabs.Content value="boundary" p={0}>
              <BlueprintDrawings />
            </Tabs.Content>
          </Tabs.Root>
        </CollapsePanel>
      </Flex>

      <Spacer flex={!isCollapsed ? 'unset' : 1} />
    </VStack>
  )
}

export default ElementsPanel
